import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="浏览常见问题"
          desc="关于内容整理方式、榜单口径和浏览体验的常见疑问，都汇总在这里。点击任意问题即可展开查看解答。"
          align="center"
        />

        <div className="mx-auto max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q} data-reveal>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left transition-colors hover:bg-primary-50/60 cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        open
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 md:px-6 md:pb-6 text-xs md:text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}